import sharedConfig from '../config'
import { createPublishService, createSeaartService } from './create'

export * from './error'
export * from './create'
export * from './helper'
export { getCurrentLine } from './wayfinder'
export { getServiceLineConfig } from '../config/service'
export type { ServiceType } from '../config/service'

// 基础请求
export const baseHttp = createSeaartService({
  basePath: sharedConfig.httpBaseUrl,
})

// 发布请求
export const publishHttp = createPublishService({
  basePath: sharedConfig.httpPublishUrl,
})

// 公共请求
export const commonHttp = createPublishService({
  basePath: sharedConfig.httpCommonUrl,
  addCommon: true,
})
